import type { LowerHex } from './hex'

export type EvmTransactionSource = `evm_${number}_${LowerHex}`

export const isEvmTransactionSource = (
  source: string,
): source is EvmTransactionSource => /^evm_\d+_0x[0-9a-f]{64}$/i.test(source)
